import { collectionState } from 'atoms/collection';
import { shipsState } from 'atoms/ships';
import { useContext, useEffect, useState } from 'react';
import { useRecoilState } from 'recoil';
import { Ship } from 'types/ship';
import FirebaseContext from '../components/Firebase/context';
import { User } from '../types/auth';

export function useUser() {
  const [user, setUser] = useState<User | undefined>(undefined);
  const { firebase }: any = useContext(FirebaseContext);

  useEffect(() => {
    if (user) return;

    firebase?.auth().onAuthStateChanged((user: any) => {
      setUser(user);
    });
  }, [user, firebase]);

  return user;
}

function getRetrofitsCount(ships: Ship[]) {
  return ships.filter((ship) => ship.retrofit === 'all').length;
}

function getCollabsCount(ships: Ship[]) {
  return ships.filter((ship) => ship.collab === 1).length;
}

export function useProgress() {
  const [collection] = useRecoilState(collectionState);
  const [ships] = useRecoilState(shipsState);
  const retrofitsCount = getRetrofitsCount(ships || []);
  const collabsCount = getCollabsCount(ships || []);

  const myShips = collection?.data.ships || [];
  const myRetrofits = collection?.data.retrofits || [];

  const myRetrofitsCount =
    ships?.filter((ship) => myRetrofits.includes(ship.id)).length || 0;

  const myCollabsCount =
    ships?.filter(
      (ship: any) => myShips.includes(ship.name) && ship.collab === 1,
    ).length || 0;

  const myColectedCount =
    ships?.filter((ship: any) => myShips.includes(ship.name)).length || 0;

  const collected = myColectedCount + myRetrofitsCount - myCollabsCount;
  const total = (ships?.length || 0) + retrofitsCount - collabsCount;

  return { collected, total };
}
